import map from 'lodash/map'
import type { PivotFilterOperatorEnum } from '@ztechapps/common.contract'
import { isPivotRangeOperator } from '../is-pivot-range-operator'

/** The operands of an operator as one phrase — `5 and 50` for a range, the first value otherwise — each in quotes when `isQuoted`. */
export const describePivotOperands = (
  operator: PivotFilterOperatorEnum,
  values: string[],
  isQuoted: boolean
): string => {
  const shown = map(values, (value) => (isQuoted ? `"${value}"` : value))
  return isPivotRangeOperator(operator) ? `${shown[0]} and ${shown[1]}` : (shown[0] ?? '')
}
